  const URL_API_BASE = process.env.REACT_APP_API_ADMIN_CONFIGURATION_URL;

export const services = {
  roles: `${URL_API_BASE}/roles`,
  users: `${URL_API_BASE}/users`,
  auth: `${URL_API_BASE}/auth`,
  analytics: `${URL_API_BASE}/analytics`,
  'environment-variables': `${URL_API_BASE}/environment-variables`,
  institutions: `${URL_API_BASE}/institutions`,
  'chat-instances': `${URL_API_BASE}/chat-instances`,
  reactions: `${URL_API_BASE}/reactions`,
  files: `${URL_API_BASE}/files`,
  procedures: `${URL_API_BASE}/procedures`,
  'comunication-channels': `${URL_API_BASE}/communication-channels`,
  machineLearning: process.env.REACT_APP_MACHINE_LEARNING_SERVICE,
};